<template>
	<v-dialog
		v-model="tieneMensajesSinLeer"
		max-width="90%"
		persistent
	>
		<v-card>
			<v-card-title class="text-h5">
				Mensajes sin leer <span class="ml-1">({{ $store.getters['mensajeria/cantidadMensajesSinLeer'] }})</span>
			</v-card-title>
			<v-card-text class="px-2">
				<v-row align="center" no-gutters>
					<v-col cols="auto">
						<v-item-group v-model="window" class="" mandatory>
							<v-item
								v-for="n in maxCantIndicadores"
								:key="'mensajesinleer'+n"
								v-slot="{ active }"
							>
								<div>
									<v-icon v-text="active ? 'radio_button_checked' : 'radio_button_unchecked'"/>
								</div>
							</v-item>
						</v-item-group>
					</v-col>
					<v-col>
						<v-window v-model="window" vertical>
							<v-window-item
								v-for="(mensaje, n) in mensajes"
								:key="n"
							>
								<v-card flat outlined>
									<v-card-subtitle class="pb-0" v-text="mensaje.fecha"/>
									<v-card-title class="pt-0" v-text="mensaje.asunto"/>
									<v-card-text v-html="mensaje.mensaje"/>
									<v-form v-model="mensaje.formValido" @submit.prevent="marcarComoLeido(mensaje, null, null)">
										<template v-for="(rows, n) in agruparOpciones(mensaje)">
											<v-card-actions :key="`opc--`+n">
												<v-row>
													<v-col :key="n+'item'+c" v-for="(opcion, c) in rows">
														
														<v-btn
															v-if="opcion.opc_key === 'boton'"
															:key="`opc--`+n" color="primary" depressed
															:disabled="(mensaje.loading && !opcion.enviando)"
															@click="respenderBtn(mensaje, opcion)"
														>
															{{ opcion.opc_value }}
														</v-btn>
														<v-textarea
															v-else-if="opcion.opc_key === 'texto'"
															:key="`opc-txt--${c}`"
															:rules="rulesText"
															:label="opcion.opc_value" outlined
															:loading="mensaje.loading === true"
															v-model="opcion.respuesta"
														/>
													</v-col>
												</v-row>
											</v-card-actions>
										</template>
									</v-form>
								</v-card>
							</v-window-item>
						</v-window>
					</v-col>
				</v-row>
			</v-card-text>
			<v-snackbar v-model="alerta.visible" bottom :color="alerta.color" :timeout="15000">
				{{ alerta.mensaje }}
				<template v-slot:action="{  }">
					<v-btn dark text @click="alerta.visible = false">
						Cerrar
					</v-btn>
				</template>
			</v-snackbar>
		</v-card>
	</v-dialog>
</template>
<script>
	
	const MAX_CHARS = 500

export default {
	name: 'MensajeriaComponent',
	computed:{
		mensajes(){
			return this.listaMensajes;
		}
		,tieneMensajesSinLeer(){
			return this.$store.getters['mensajeria/tieneMensajesSinLeer'];
		}
		,maxCantIndicadores(){
			const cantSinLeer = this.$store.getters['mensajeria/cantidadMensajesSinLeer'];
			const maxIndicadores = 10
			return cantSinLeer>maxIndicadores?maxIndicadores:cantSinLeer;
		}
	}
	,data() {
		return {
			window: 0,
			respuestas:{}
			,listaMensajes:[]
			,sub: null
			,rulesText:[
				v=>v.length<MAX_CHARS || `Límite de ${MAX_CHARS} excedido.`
			]
			,alerta:{
				visible:false
				,color:'error'
				,mensaje:''
			}
		}
	},
	methods:{
		getOpciones(mensaje){
			return Object.values(mensaje.opciones)
		},
		agruparOpciones(mensaje){
			const rows = [];
			let opciones = mensaje.opciones;
			let col = [];

			for( let opcion of opciones.toSorted((a,b)=>(a.opc_order-b.opc_order) )){
				
				if( opcion.opc_key === 'boton' ){
					
					if( col.length === 0 ){
						col.push(opcion);
					}else if( opcion.opc_key === 'boton' && col[col.length-1].opc_key === 'boton' ){
						col.push(opcion);
					}else{
						// col.push(opcion);
						rows.push(col);
						col = [opcion]
					}
				}else{
					
					if(col.length)	rows.push(col);
					rows.push([opcion]);
					col = []
				}
			}
			if( col.length > 0 )	rows.push(col);

			return rows;
		},
		async respenderBtn(mensaje, opc){
			// if( !Object.hasOwn(mensaje, 'respuesta') ){
				this.$set(mensaje, 'respuesta', []);
			// }
			
			mensaje.respuesta.push({
				valor: opc.opc_value,
				opc_key: opc.opc_key,
				orden: opc.opc_order,
			});

			this.marcarComoLeido(mensaje);
		}
		,async marcarComoLeido(mensaje){
			
			const {grupo, hash, opciones=[], respuesta=[]} = mensaje;
			const respuestas = respuesta

			for(  let opc of opciones ){
				if( Object.hasOwn(opc, 'respuesta') && !!opc.respuesta ){
					respuestas.push({
						valor: opc.respuesta,
						opc_key: opc.opc_key,
						orden: opc.opc_order,
					})
				}
			}

			// console.log('respuestas', respuestas)

			// return 
			
			for( let opc in mensaje.opciones ){
				let opcion = mensaje.opciones[opc];
				
				if( Object.hasOwn(opcion, 'respuesta') ){
					if( !!opcion.respuesta && opcion.respuesta.length > MAX_CHARS ){
						this.showError('Respuesta demasiado larga');
						return;
					}
					this.$store.commit('mensajeria/MARCAR_RESPUESTA', {
						grupo: mensaje.grupo
						, hashMensaje: mensaje.hash
						, opcionTipo: opcion.tipo
						, opcionTexto: opcion.texto
						, respuesta: opcion.respuesta
					});
				}
			}
			
			mensaje.loading = true;
			const usuario = this.$store.getters['usuario/usuario'];
			const contribuyente = this.$store.getters['empresas/selectedRut'];
			const payload = {
				usuario, contribuyente, mensaje, respuestas
			}
			let resp = await this.$store.dispatch('mensajeria/marcarComoLeido', payload);
			mensaje.loading = false;
			return resp;
		}
		,showAlerta(tipo, mensaje){
			this.alerta.visible = true;
			this.alerta.color = tipo;
			this.alerta.mensaje = mensaje;
		}
		,showError(mensaje){
			this.showAlerta('error', mensaje);
		}
		,showSuccess(mensaje){
			this.showAlerta('success', mensaje);
		}
	}
	,mounted(){
		
		const callback = ({type}={}, state)=>{
			const escuchando = ['mensajeria/MARCAR_LEIDO', 'mensajeria/SET_MENSAJES'
				, 'mensajeria/DESMARCAR_LEIDO', 'mensajeria/MARCAR_LEYENDO']
			
			if(  !escuchando.includes(type) ){
				return;
			}
			
			const msgs = this.$store.getters['mensajeria/mensajesNoLeidos']
			this.$set(this, 'listaMensajes', JSON.parse(JSON.stringify(msgs)));
			for(  let i = 0; i < this.listaMensajes.length; i++){
				let current = this.listaMensajes[i];
				this.$set(current, 'leido', false);
				this.$set(current, 'loading', current.loading);
				this.$set(current, 'opciones', current.opciones);
				this.$set(current, 'formValido', false);

				for( let j = 0; j < current.opciones.length; j++){
					let currentOpcion = current.opciones[j];
					this.$set(currentOpcion, 'respuesta', '');
					this.$set(currentOpcion, 'enviando', false);
				}
			}
		}
		this.sub = this.$store.subscribe(callback);
		// callback()
	}
	,beforeDestroy(){
		if( !!this.sub )	this.sub();
	}
	,watch:{
	}
}
</script>